module.exports = __webpack_public_path__ + "static/media/dashboard-scape-card-3-icon.4be59cfa.svg";